import { openDB } from "idb";

export const dbPromise = openDB("estDB", 1, {
  upgrade(db) {
    const tabs = [
      "Est_List_of_Measures",
      "Est_Endpoints_Fields",
      "Est_Field_Descriptions",
      "Est_Wealth_Packages",
      "Est_Segmentation"
    ];
    for (const tab of tabs) {
      if (!db.objectStoreNames.contains(tab)) {
        db.createObjectStore(tab, { keyPath: "content" });
      }
    }
  },
});

export async function addItem(tab, items) {
  const db = await dbPromise;
  for(let item of items){
    db.put(tab, item)
  }
  return ;
}

export async function getAllItems(tab) {
  const db = await dbPromise;
  return db.getAll(tab);
}

export async function getItem(tab, id) {
  const db = await dbPromise;
  return db.get(tab, id);
}

export async function deleteItem(tab, id) {
  const db = await dbPromise;
  return db.delete(tab, id);
}

export async function clearStore(tab) {
  const db = await dbPromise;
  return db.clear(tab);
}

export async function clearAllStores() {
  const db = await dbPromise;
  const storeNames = db.objectStoreNames;
  for (const storeName of storeNames) {
    await db.clear(storeName);
  }
  return true;
}